export default __webpack_public_path__ + "static/media/transaction.d075140c.svg";